import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, FormControlLabel, Switch, TextField, Typography } from '@mui/material';
import { getVoiceAdminSettings, updateVoiceAdminSettings } from '../../../api/backendApi';

export default function FeatureFlagsTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const refresh = async () => {
    setLoading(true); setError('');
    try {
      const resp = await getVoiceAdminSettings();
      const cfg = resp?.data || resp || {};
      setData({
        NUMBER_RESOLVER_ENABLED: !!(cfg?.flags?.NUMBER_RESOLVER_ENABLED ?? cfg?.NUMBER_RESOLVER_ENABLED),
        SMS_NUMBER_RESOLVER_ENABLED: !!(cfg?.flags?.SMS_NUMBER_RESOLVER_ENABLED ?? cfg?.SMS_NUMBER_RESOLVER_ENABLED),
        VOICE_NUMBER_RESOLVER_ENABLED: !!(cfg?.flags?.VOICE_NUMBER_RESOLVER_ENABLED ?? cfg?.VOICE_NUMBER_RESOLVER_ENABLED),
        requireTenantNumberForOutbound: !!(cfg?.requireTenantNumberForOutbound),
        defaultRegion: cfg?.defaultRegion || '',
      });
    } catch (e) {
      setError(String(e?.message || 'Failed to load settings'));
    } finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  const patch = async (patchData) => {
    setSaving(true);
    try {
      const next = { ...(data || {}), ...patchData };
      setData(next);
      await updateVoiceAdminSettings(patchData);
    } catch (e) {
      setError(String(e?.message || 'Failed to update settings'));
    } finally { setSaving(false); }
  };

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={24} /></Box>;
  if (error) return <Box sx={{ color: 'error.main' }}>{error}</Box>;
  if (!data) return null;

  return (
    <Box>
      <FormControlLabel
        control={<Switch checked={!!data.NUMBER_RESOLVER_ENABLED} onChange={e => patch({ NUMBER_RESOLVER_ENABLED: e.target.checked })} />}
        label="NUMBER_RESOLVER_ENABLED"
      />
      <FormControlLabel
        control={<Switch checked={!!data.SMS_NUMBER_RESOLVER_ENABLED} onChange={e => patch({ SMS_NUMBER_RESOLVER_ENABLED: e.target.checked })} />}
        label="SMS_NUMBER_RESOLVER_ENABLED"
      />
      <FormControlLabel
        control={<Switch checked={!!data.VOICE_NUMBER_RESOLVER_ENABLED} onChange={e => patch({ VOICE_NUMBER_RESOLVER_ENABLED: e.target.checked })} />}
        label="VOICE_NUMBER_RESOLVER_ENABLED"
      />
      <FormControlLabel
        control={<Switch checked={!!data.requireTenantNumberForOutbound} onChange={e => patch({ requireTenantNumberForOutbound: e.target.checked })} />}
        label="Require tenant number for outbound (global default)"
      />
      <Box sx={{ mt: 2, maxWidth: 360 }}>
        <TextField
          label="Default Region"
          fullWidth
          value={data.defaultRegion}
          onChange={e => patch({ defaultRegion: e.target.value })}
        />
      </Box>
      {saving && <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>Saving...</Typography>}
    </Box>
  );
}
